import { ApiGetUser, ApiSignIn } from "src/models/Auth";
import { useApi } from "./api";
import { ApiGetPermissions } from "src/models/Permission";
import { ApiGetGroup, ApiGetGroups } from "src/models/Equipes";
import { ApiGetEmployee, ApiGetFuncionario, AtualizarFuncionarioPayload } from "src/models/Funcionario";
import { ApiGetTask, ApiGetTasks, ApiGetStatus } from "src/models/Producao";
import {
  ApiGetEtapas,
  ApiGetEtapa,
  ApiGetEtapasCategoria,
  EtapaFuncionarioResponse,
  ControleEtapaResponse
} from 'src/models/Etapa';
import { ApiGetCategorias, ApiGetCategoriasComGrafo } from '../models/Categoria';
import { ApiGetPCP, ApiResponseProducao, ProductionData } from '../models/PCP';
import { DiasUteisResponse } from 'src/models/Dias'
import { AlterarCategoriaProdutoPayload, ApiGetProdutos } from '../models/Produto';

// Authentication - Usando rotas padronizadas em português
const signIn = async ({ email, password }: { email: string, password: string }) => {
    const response = await useApi<ApiSignIn>('autenticador/entrar', 'POST', { email, password }, false);
    return response;
}

const getUser = async () => {
    const response = await useApi<ApiGetUser>('autenticador/usuario');
    return response;
}


// Groups / Permissions
const getPermissions = async () => {
    const response = await useApi<ApiGetPermissions>('servicos/permissoes');
    return response;
}

const getGroups = async () => {
    const response = await useApi<ApiGetGroups>('servicos/equipes');
    return response;
}

const getAnGroup = async (id: number) => {
    const response = await useApi<ApiGetGroup>(`servicos/equipes/${id}`);
    return response;
}

const addGroup = async ({ name, permissions }: { name: string, permissions: string }) => {
    const response = await useApi('servicos/equipes', 'POST', { name, permissions });
    return response;
}

const editGroup = async (id: number, { name, permissions }: { name?: string, permissions?: string }) => {
    const response = await useApi(`servicos/equipes/${id}`, 'PUT', { name, permissions });
    return response;
}

const deleteGroup = async (id: number) => {
    const response = await useApi(`servicos/equipes/${id}`, 'DELETE');
    return response;
}


// Employees - Usando rota padronizada em português
const getEmployees = async () => {
    const response = await useApi<ApiGetFuncionario>('autenticador/funcionarios');
    return response;
}

//const getAnEmployee = async (id: number) => {
//    const response = await useApi<ApiGetEmployee>(`servicos/funcionarios/${id}`);
//    return response;
//}

const addEmployee = async ({ name, email, password }: { name: string, email: string, password: string}) => {
    const response = await useApi('servicos/funcionarios', 'POST', { name, email, password });
    return response;
}

const editEmployee = async (id: number, { nome, email }: { nome?: string, email?: string }) => {
    const response = await useApi(`servicos/funcionarios/${id}`, 'PUT', { nome, email });
    return response;
}

const deleteEmployee = async (id: number) => {
    const response = await useApi(`servicos/funcionarios/${id}`, 'DELETE');
    return response;
}

//const getProductionData = async () => {
//    const response = await useApi('servicos/pcp', 'GET');
//    return response
//}

const getProductionData = async (pagina: number = 1, tipo?: string) => {
  const queryParams = new URLSearchParams({ pagina: String(pagina) });
  if (tipo) queryParams.append('tipo', tipo);

  const response = await useApi(`servicos/pcp?${queryParams.toString()}`, 'GET');
  return response;
};

interface FiltrosBusca {
  lote?: string;
  codigo?: string;
  produto?: string;
}

const getProductionDataFiltred = async (filtros: FiltrosBusca = {}) => {
  const params = new URLSearchParams();

  if (filtros.lote) params.append('lote', filtros.lote);
  if (filtros.codigo) params.append('codigo', filtros.codigo);
  if (filtros.produto) params.append('produto', filtros.produto);

  const query = params.toString();
  const response = await useApi(`servicos/pcp_busca?${query}`, 'GET');
  return response;
};

const getPCPStatusData = async () => {
    const response = await useApi('servicos/pcp_status', 'GET');
    return response
}

// Função para pegar a lista de etapas que o funcionário pode acessar
const getEtapaFuncionarioData = async () => {
    const response = await useApi<EtapaFuncionarioResponse>("servicos/etapa_funcionario", "GET");
    return response
}

// Função para alterar a data de uma etapa
const updateDataEtapa = async ({ id, nova_data }) => {
  const response = await useApi<ApiResponseProducao>("servicos/data_etapa", "POST", { id, nova_data });
  return response;
};

// Função para alterar a prioridade da Ordem de Serviço
const alterarPrioridade = async ({ id, prioridade }: { id: number, prioridade: number }) => {
    const response = await useApi<ApiResponseProducao>('servicos/prioridade', 'POST', { id, prioridade });
    return response;
};

// Função para inicializar a Ordem de Serviço
const startOS = async ({ id }) => {
  const response = await useApi("servicos/ordem_servico/inicializar", "POST", { id });
  return response;
};

// Função para deletar uma Ordem de Serviço (deleta todo o lote)
const deleteOS = async (id: number) => {
  const response = await useApi(`servicos/ordem_servico/${id}/`, 'DELETE');
  return response;
}

// Função para listar as informações de uma Etapa
const getControleEtapaData = async (etapa_id: number) => {
    const response = await useApi<ControleEtapaResponse>(`servicos/controle_etapa?etapa_id=${etapa_id}`, "GET");
    return response;
}

// Função para atualizar as etapas de produção
const updateEtapaProducao = async (
    id: number,
    { status_id, observacao }: { status_id: number, observacao?: string }
) => {
    const response = await useApi('servicos/controle_etapa', 'POST', { id, status_id, observacao });
    return response;
};

const editPCP = async (
    id: number,
    data_inicial: string
) => {
    const response = await useApi<ApiResponseProducao>(`servicos/pcp/${id}`, 'PUT', {
        data_inicial: data_inicial
    });
    return response;
};

// Função para editar uma Ordem de Serviço (apenas lote e tipo)
const editOrdemServico = async (
    id: number,
    payload: {
        lote?: string,
        tipo: string
    }
) => {
    const response = await useApi<ApiResponseProducao>(`servicos/ordem_servico/${id}/`, 'PUT', payload);
    return response;
};

// Tasks
const getTasks = async () => {
    const response = await useApi<ApiGetTasks>('servicos/producao');
    return response;
}

const getAnTask = async (id: number) => {
    const response = await useApi<ApiGetTask>(`servicos/producao/${id}`);
    return response;
}

const addTask = async(
    { data_inicial_prevista, data_final_prevista, data_inicial_real, data_final_real, feito }: { data_inicial_prevista: string, data_final_prevista?: string, data_inicial_real?: string, data_final_real: number, feito: number }
) => {
    const response = await useApi<ApiGetTask>('servicos/producao', 'POST', { data_inicial_prevista, data_final_prevista, data_inicial_real, data_final_real, feito });
    return response;
}

const editTask = async (
    id: number,
    data_inicial_prevista: string,
    status_id: number
) => {
    const response = await useApi<ApiGetTask>(`servicos/producao/${id}`, 'PUT', {
        data_inicial_prevista,
        status_id
    });
    return response;
};

const deleteTask = async (id: number) => {
    const response = await useApi(`servicos/producao/${id}`, 'DELETE');
    return response;
}

const getStatusTask = async () => {
    const response = await useApi<ApiGetStatus>('servicos/status_producao');
    return response;
}

// Obter todas as etapas
const getEtapas = async () => {
    const response = await useApi<ApiGetEtapas>('servicos/etapa');
    return response;
}

// Adicionar uma nova etapa
const addEtapa = async (nome: string) => {
  const response = await useApi('servicos/etapa', 'POST', { nome });
  return response;
}

// Adicionar etapas anteriores e relacionar categoria

const addEtapaAnterior = async (id_categoria: number, id_etapa: number, dias_etapa: number, tipo: string, ids_etapa_anterior?: string) => {
    const response = await useApi<ApiGetEtapasCategoria>('servicos/etapa/categoria', 'POST', { id_categoria, id_etapa, ids_etapa_anterior, dias_etapa, tipo });
    return response;
}

// Altera ligação entre etapas para uma categoria
const alterEtapaCategoria = async(
    { categoria_id, etapa_id, novos_pais, novos_filhos }:
    { categoria_id: number, etapa_id: number, novos_pais?: string, novos_filhos?: string }
) => {
    const response = await useApi<ApiGetEtapasCategoria>(
        'servicos/etapa/categoria/editar',
        'POST',
        {
            categoria_id,
            etapa_id,
            novos_pais,
            novos_filhos
        }
    );
    return response;
};

// Cadastro de funcionários
const addFuncionario = async (
  nome: string,
  email: string,
  senha: string,
  equipe_id: number
) => {
  const payload = {
    nome,
    email,
    senha,
    equipe_id,
  };

  const response = await useApi("servicos/funcionarios/novo", "POST", payload);

  return response;
};


// Registrar categoria
const addCategoria = async (nome: string) => {
    const response = await useApi('servicos/categoria', 'POST', { nome });
    return response;
}

const getCategorias = async () => {
    const response = await useApi<ApiGetCategorias>('servicos/categoria');
    return response;
}

// Renomear categoria
const editCategoria = async (id: number, nome: string) => {
    const response = await useApi(`servicos/categoria/${id}`, 'PUT', { nome });
    return response;
}

// Excluir categoria (backend bloqueia se houver produtos/etapas vinculadas)
const deleteCategoria = async (id: number) => {
    const response = await useApi(`servicos/categoria/${id}`, 'DELETE');
    return response;
}

const getProdutos = async () => {
  const response = await useApi<ApiGetProdutos>('servicos/produto');
  return response;
};

const alterarCategoriaProduto = async (payload: AlterarCategoriaProdutoPayload) => {
  const response = await useApi<ApiGetProdutos>('servicos/produto/alterar', 'POST', payload);
  return response;
};

const getDiasUteis = async () => {
    const response = await useApi<DiasUteisResponse>('servicos/dias_uteis', 'GET');
    return response.data;
}

const postDiaUtil = async (data: string) => {
    const response = await useApi<DiasUteisResponse>(
      'servicos/dias_uteis',
      'POST',
      { data }
    );
    return response.data;
}

// Novos para funcionários
const postAtualizarFuncionario = async (payload: AtualizarFuncionarioPayload) => {
  const response = await useApi<ApiGetFuncionario>(
    'servicos/funcionarios', // ajuste se o endpoint for diferente
    'POST',
    payload
  );

  return response.data;
};

const getEmpregados = async () => {
    const response = await useApi<ApiGetFuncionario>('servicos/funcionarios', 'GET');
    return response.data;
}

const getEquipes = async () => {
    const response = await useApi<ApiGetGroups>('servicos/equipes', 'GET');
    return response.data;
}

// Grafo Etapas Categorias
const getGrafosCategorias = async () => {
    const response = await useApi<ApiGetCategoriasComGrafo>('servicos/categorias/grafo_etapas', 'GET');
    return response.data;
}
/*
const getCategorias = async () => {
    try {
        const response = await useApi('servicos/categoria', 'GET');
        const data = await response;
        return data;  // Certifique-se de que está retornando um array aqui
    } catch (error) {
        console.error('Erro ao buscar categorias:', error);
        return [];  // Retorna um array vazio em caso de erro
    }
};
*/


// Exporting all requests
export const useRequests = () => {
  return {
    // Auth
    signIn,
    getUser,

    // Groups/ Permissions
    getPermissions,
    getGroups,
    getAnGroup,
    addGroup,
    editGroup,
    deleteGroup,

    // Employees
    getEmployees,
    //getAnEmployee,
    addEmployee,
    editEmployee,
    deleteEmployee,

    // Tasks
    getTasks,
    getAnTask,
    addTask,
    editTask,
    deleteTask,
    getStatusTask,

    // Etapas
    getEtapas,
    addEtapa,
    addEtapaAnterior,

    // Categorias
    addCategoria,
    getCategorias,
    editCategoria,
    deleteCategoria,

    getProductionData,
    getPCPStatusData,
    editPCP,
    updateDataEtapa,
    startOS,
    alterarPrioridade,

    getEtapaFuncionarioData,
    getControleEtapaData,

    updateEtapaProducao,

    // Calendario
    getDiasUteis,
    postDiaUtil,

    getEmpregados,
    postAtualizarFuncionario,
    getEquipes,
    getGrafosCategorias,

    alterEtapaCategoria,
    addFuncionario,

    // Produtos
    getProdutos,
    alterarCategoriaProduto,

    getProductionDataFiltred,

    deleteOS,
    editOrdemServico,
  };
};